export default __webpack_public_path__ + "static/media/hashkey.ed2e8d55.png";